
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DescribeData from "./describe.vue";
import H5ReportDialog from "./dialog/index.vue";
import {
  CandidateNewResult,
  TacPsycGauge
} from "@/lib/model/exam/candidate-result";

enum LevelClass {
  "safe",
  "warning",
  "danger",
  "primary"
}
const DONE_CODE = 1; // 完成code

@Component({ components: { H5ReportDialog, DescribeData } })
export default class Psychological extends Vue {
  @Prop() index!: number;
  @Prop({ type: CandidateNewResult, default: () => new CandidateNewResult() })
  all!: CandidateNewResult; //候选人信息 所有表
  @Prop({ type: TacPsycGauge, default: () => new TacPsycGauge() })
  psyGauge!: TacPsycGauge;

  get isFinish(): boolean {
    return this.psyGauge.isFinish === DONE_CODE;
  }

  get LevelClass() {
    return LevelClass;
  }

  get obvervationalEvaluateLevel() {
    return this.psyGauge.psycGaugeResult.obvervationalEvaluateShowList.length
      ? LevelClass.danger
      : LevelClass.safe;
  }

  showReadingGuide = false;

  @Watch("showReadingGuide")
  handleDialogChange(val: boolean) {
    if (val) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "scroll";
    }
  }
}
